<div class="page-container">
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" id="page-header" i18n>External Vendor Files</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-ext-vendor-save-btn" role="button" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid || !isAuthorized || isSaving">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-ext-vendor-reset-btn" role="button" class="ot-btn ot-btn--is-secondary"
          (click)="reset()" [disabled]="!settingsForm.dirty || !isAuthorized || isSaving" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <div style="height: calc(100vh - 165px);">
    <div class="settings-area">
      <form class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2 ot-grid--is-3-columns" [formGroup]="settingsForm"
        name="otsc-settings-ext-vendor-form">
        <div class="ot-col ot-row__column ot-row__column--is-50">
          <div class="ot-row">
            <div class="ot-col ot-row__column">
              <app-checkbox [identifier]="'useRestrictionsCtrl'" formControlName="useRestrictionsCtrl"
                [name]="'useRestrictionsCtrl'" i18n-label [label]="'Enable restrictions'" i18n-arialabel
                [arialabel]="'Enable external vendor file restrictions'" [disabled]="true" [toggle]="true"
                i18n-description [description]="'Enable external vendor file restrictions.'">
              </app-checkbox>
            </div>
          </div>
          <div id="otsc-settings-max-file-count">
            <div class="ot-row">
              <div class="ot-col ot-row__column ot-row__column--is-75">
                <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : maxFileCountCtrl.invalid}">
                  <label class="ot-form-control__label" for="max-file-count" i18n>
                    Max file count
                  </label>
                  <div class="ot-form-control__input-group">
                    <input id="max-file-count" formControlName="maxFileCountCtrl" i18n-placeholder
                      placeholder="Enter the maximum number of files" type="number" maxlength="2"
                      class="ot-input ot-input--is-expanded"
                      [readonly]="!useRestrictionsCtrl.value || !isAuthorized || isSaving" min="0">
                    <span class="ot-form-control__error-icon">
                    </span>
                  </div>
                  @if (maxFileCountCtrl.invalid) {
                  <p id="invalidMaxFileCountMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Invalid max file count value, the minimum is 0.
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ot-col ot-row__column ot-row__column--is-50">
          <div id="otsc-settings-max-file-size">
            <div class="ot-row">
              <div class="ot-col ot-row__column ot-row__column--is-75">
                <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : maxFileSizeCtrl.invalid}">
                  <label class="ot-form-control__label" for="max-file-size" i18n>
                    Max file size (in megabytes)
                  </label>
                  <div class="ot-form-control__input-group">
                    <input id="max-file-size" formControlName="maxFileSizeCtrl" i18n-placeholder
                      placeholder="Enter the maximum file size" type="number" maxlength="2"
                      class="ot-input ot-input--is-expanded"
                      [readonly]="!useRestrictionsCtrl.value || !isAuthorized || isSaving" min="0">
                    <span class="ot-form-control__error-icon">
                    </span>
                  </div>
                  @if (maxFileSizeCtrl.invalid) {
                  <p id="invalidMaxFileSizeMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Invalid max file size value, the minimum is 0.
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>
          <div id="otsc-settings-maximum-disk-space">
            <div class="ot-row">
              <div class="ot-col ot-row__column ot-row__column--is-75">
                <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : maxDiskSpaceCtrl.invalid}">
                  <label class="ot-form-control__label" for="max-disk-space" i18n>
                    Max allowed disk space (in megabytes)
                  </label>
                  <div class="ot-form-control__input-group">
                    <input id="max-disk-space" formControlName="maxDiskSpaceCtrl" i18n-placeholder
                      placeholder="Enter the maximum amount of disk space" type="number" maxlength="2"
                      class="ot-input ot-input--is-expanded"
                      [readonly]="!useRestrictionsCtrl.value || !isAuthorized || isSaving" min="0">
                    <span class="ot-form-control__error-icon">
                    </span>
                  </div>
                  @if (maxDiskSpaceCtrl.invalid) {
                  <p id="invalidMaxDiskSpaceMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                    Invalid max disk space value, the minimum is 0.
                  </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ot-col ot-row__column ot-row__column--is-50">
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-75">
              <div class="ot-form-control ot-mb-0" [ngClass]="{'ot-form-control--is-invalid' : allowedFileCtrl.invalid}"
                style="margin-bottom: 0px !important;">
                <label class="ot-form-control__label" for="extension" i18n>
                  Only allow the upload of files with the following extensions (empty allows all extensions):
                </label>
                <div class="ot-form-control ot-form-control--is-horizontal"
                  [ngClass]="{'chip-error': allowedFileCtrl.dirty &&allowedFileCtrl.errors?.pattern}"
                  style="margin-bottom: 0px !important;">
                  <input id="allowedFileCtrl" formControlName="allowedFileCtrl"
                    placeholder="Enter an allowed file extension" type="text" maxlength="50"
                    class="ot-input ot-input--is-expanded"
                    [readonly]="!useRestrictionsCtrl.value || !isAuthorized || isSaving">
                  <button id="addAllowedFileBtn" style="height: 32px;width: 32px;"
                    class="ot-btn ot-icon ot-icon--is-action-icon otsc-icon-sprite-add" (click)="addToAllowedList()"
                    title="Add" i18n-title
                    [disabled]="!useRestrictionsCtrl.value || !isAuthorized || isSaving"></button>
                </div>
                @if (allowedFileCtrl.dirty && allowedFileCtrl.errors?.pattern) {
                <p id="invalidExtensionError" class="ot-form-control__error-text" i18n autocomplete="off">
                  Invalid extension.
                </p>
                }
              </div>

            </div>
          </div>
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-75" style="height: 114px;">
              <ng-scrollbar>
                <div class="ot-chips" id="allowedFileExtChips">
                  @for (allowedFile of allowedExtList; track allowedFile; let i = $index) {
                  <div class="ot-chip">
                    {{allowedFile}}
                    @if (isAuthorized && useRestrictionsCtrl.value) {
                    <button [attr.otdata]="allowedFile" aria-label="Remove" i18n-aria-label i18n-title title="Remove"
                      class="ot-chip__close" (click)="removeFromAllowedList(i)"
                      [disabled]="!useRestrictionsCtrl.value || !isAuthorized || isSaving">
                    </button>
                    }
                  </div>
                  }
                </div>
              </ng-scrollbar>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div style="height: calc(100vh - 403px)">
      <app-datatable [identifier]="'external-vendor-table'" [title]="'Available Files'" [showcheckboxes]="true"
        [cols]="cols" [rows]="rows" [scroll]="true" [pagination]="true" [total]="total" [isloading]="loading"
        (actionmenuevent)="actionMenuClicked($event)" (pageevent)="onPageChange($event)" [showfiltericon]="true"
        [filters]="filters" [showdragdrop]="true" (onclickdragdrop)="onClickDragDrop()"
        [isSortable]="false"></app-datatable>
    </div>
  </div>
</div>